import { registerPropertyManagerSection } from '@/core';
import RibPropertySection from '@/components/editor/property-manager/rib/RibPropertySection.vue';

/**
 * 注册筋属性面板。
 *
 * 设计说明：
 * 1. 与抽壳/圆角同一注册契约：isApplicable 控制面板可见性，actions 控制确认/取消；
 * 2. 筋面板只负责展示与参数修改，提交/取消统一回调 context 注入的动作。
 */
registerPropertyManagerSection({
    id: 'rib-feature',
    title: '筋',
    order: 33,
    component: RibPropertySection,
    actions: {
        confirm: true,
        cancel: true,
    },
    resolveConfirmDisabled: (context) => context.ribCanSubmit === false,
    isApplicable: (context) => {
        if (context.activeCommand === 'rib') {
            return true;
        }
        return context.ribActive === true;
    },
    onConfirm: (context) => {
        void context.submitRib?.();
    },
    onCancel: (context) => {
        context.cancelRib?.();
    },
});
